import moment from 'moment-timezone'

export default moment.utc().local().startOf('day')
